import type { ReactElement } from "react";
import { useEffect } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { useIsTruncatedElement } from "app/pages/sales-intelligence/common-components/TruncatedText";

import { StyledChipTooltip, StyledChipTruncatedText, StyledSelectableChipItem } from "./styles";

interface IProps {
    isSelected?: boolean;
    label: string;
    onClick?: () => void;
}

const SelectableChipItem = ({ label, isSelected, onClick }: IProps): ReactElement => {
    const { ref, isTruncated, recalculate } = useIsTruncatedElement<HTMLSpanElement>();

    useEffect(() => {
        recalculate();
    }, [isSelected]);

    return (
        <StyledChipTooltip
            content={label}
            enabled={isTruncated}
        >
            <StyledSelectableChipItem
                isSelected={isSelected}
                onClick={onClick}
            >
                {isSelected ? (
                    <SWReactIcons
                        iconName="checked"
                        size="xs"
                    />
                ) : null}

                <StyledChipTruncatedText
                    fontVariant="sectionTitle"
                    paddingX="4px"
                    labelRef={ref}
                >
                    {label}
                </StyledChipTruncatedText>
            </StyledSelectableChipItem>
        </StyledChipTooltip>
    );
};

export default SelectableChipItem;
